import axios from "axios";

const BASE_API_URL = "/api/onlinemobility/finance";

export function calculate(dealerCode, formData) {
  let config = {
    headers: {
      "X-OMF-ENHANCE-AUTHENTICATION": true,
    },
  };

  return axios
    .post(`${BASE_API_URL}/${dealerCode}/calculate`, formData, config)
    .then(result => result.data);
}
